<template>
  <v-layout row wrap>

    <v-flex xs12 sm6 md3>
      <autocomplete
        :label="$t('label.paese')"
        item-value="id" item-text="nome"
        :items="paesi" v-model="_paese" :loading="paesiLoading"
        :required="required" :disabled="isPaeseDisabled"
        v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm6 md3>
      <autocomplete
        :label="$t('label.regione')"
        item-value="id" item-text="nome"
        :items="regioni" v-model="_regione" :loading="regioniLoading"
        :disabled="isRegioneDisabled" :required="required"
        v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm6 md3>
      <autocomplete
        :label="$t('label.provincia')"
        item-value="id" item-text="nome"
        :items="province" v-model="_provincia" :loading="provinceLoading"
        :disabled="isProvinciaDisabled" :required="required"
        v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm6 md3>
      <autocomplete
        :label="$t('label.comune')"
        item-value="id" item-text="nome"
        :items="comuni" v-model="_comune" :loading="comuniLoading"
        :disabled="isComuneDisabled" :required="required"
        v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm5 md3>
      <text-field :label="$t('label.cap')" v-model="_cap" :required="required" v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm8 md6>
      <text-field :label="$t('label.via')" v-model="_via" :required="required" v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm4 md3>
      <text-field :label="$t('label.numero_civico')" v-model="_numeroCivico" :required="required" v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm7 md3 v-if="showFrazione">
      <text-field :label="$t('label.frazione')" v-model="_frazione" v-bind="$attrs"/>
    </v-flex>

    <v-flex xs12 sm4 md3>
      <text-field :label="$t('label.telefono')" v-model="_telefono" v-bind="$attrs"/>
    </v-flex>

    <!-- PTR
    <v-flex xs12 sm4 md3>
      <text-field :label="$t('label.telefax')" v-model="_telefax" v-bind="$attrs"/>
    </v-flex>
    -->

  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    inheritAttrs: false,
    name: 'IndirizzoSelect',
    props: {
        paese: String,
        regione: Number,
        provincia: Number,
        comune: Number,
        cap: String,
        frazione: String,
        via: String,
        numeroCivico: String,
        telefono: String,
        //telefax: String,  PTR
        //  La frazione non è richiesta in tutte le tabelle
        showFrazione: Boolean,
        paeseDisabled: Boolean,
        globalDisabled: Boolean,
        required: Boolean
    },
    created () {
        (async () => {
            //  Caricamento dati inziale
            await this.loadPaesi()
            if (this._paese) await this.loadRegioni(this._paese)
            if (this._regione) await this.loadProvince(this._regione)
            if (this._provincia) await this.loadComuni(this._provincia)
        })().catch(e => {
            this.$snackbar.showServerError(e)
        })
    },
    methods: {
        ...mapActions(['loadPaesi', 'loadRegioni', 'loadProvince', 'loadComuni']),
        load (method, id) {
            return this.$store.dispatch(method, id).catch(e => {
                this.$snackbar.showServerError(e)
            })
        }
    },
    watch: {
        paese (val) {
            if (val) this.load('loadRegioni', val)
        },
        regione (val) {
            if (val) this.load('loadProvince', val)
        },
        provincia (val) {
            if (val) this.load('loadComuni', val)
        }
    },
    computed: {
        paesi () {
            return this.$store.getters.paesi
        },
        regioni () {
            return this.$store.getters.regioni(this._paese)
        },
        province () {
            return this.$store.getters.province(this._regione)
        },
        comuni () {
            return this.$store.getters.comuni(this._provincia)
        },
        paesiLoading () {
            return this.$store.getters.paesiLoading
        },
        regioniLoading () {
            return this.$store.getters.regioniLoading(this._paese)
        },
        provinceLoading () {
            return this.$store.getters.provinceLoading(this._regione)
        },
        comuniLoading () {
            return this.$store.getters.comuniLoading(this._provincia)
        },
        _paese: {
            get () {
                return this.paese
            },
            set (val) {
                if (val !== this.paese) {
                    this.$emit('update:paese', val)
                    this._regione = null
                    if (val) this.load('loadRegioni', val)
                }
            }
        },
        _regione: {
            get () {
                return this.regione
            },
            set (val) {
                if (val !== this.regione) {
                    this.$emit('update:regione', val)
                    this._provincia = null
                    if (val) this.load('loadProvince', val)
                }
            }
        },
        _provincia: {
            get () {
                return this.provincia
            },
            set (val) {
                if (val !== this.provincia) {
                    this.$emit('update:provincia', val)
                    this._comune = null
                    if (val) this.load('loadComuni', val)
                }
            }
        },
        _comune: {
            get () {
                return this.comune
            },
            set (val) {
                this.$emit('update:comune', val)
            }
        },
        _cap: {
            get () {
                return this.cap
            },
            set (val) {
                this.$emit('update:cap', val)
            }
        },
        _frazione: {
            get () {
                return this.frazione
            },
            set (val) {
                this.$emit('update:frazione', val)
            }
        },
        _via: {
            get () {
                return this.via
            },
            set (val) {
                this.$emit('update:via', val)
            }
        },
        _numeroCivico: {
            get () {
                return this.numeroCivico
            },
            set (val) {
                this.$emit('update:numeroCivico', val)
            }
        },
        _telefono: {
            get () {
                return this.telefono
            },
            set (val) {
                this.$emit('update:telefono', val)
            }
        },
        /* PTR
        _telefax: {
            get () {
                return this.telefax
            },
            set (val) {
                this.$emit('update:telefax', val)
            }
        }
        */
        isPaeseDisabled(){
            return this.paeseDisabled || this.globalDisabled;
        },
        isRegioneDisabled() {
            return !this._paese || this.globalDisabled;
        },
        isProvinciaDisabled() {
            return !this._regione || this.globalDisabled;
        },
        isComuneDisabled() {
            return !this._provincia || this.globalDisabled;
        }
    }
}
</script>
